import pages from "./publicPages.json";

export const SITE_URL = pages.siteUrl;

export function getPageLocales(path, supportedLocales) {
  return pages.paths.includes(path) ? supportedLocales : [];
}
